import NextScript, { ScriptProps as NextScriptProps } from 'next/script';

import { Script } from '@/lib/types';

export interface HtmlScriptProps extends NextScriptProps {
  id: string;
  html: string;
}

export const HtmlScript: React.FC<HtmlScriptProps> = ({
  id,
  html,
  ...props
}) => (
  <NextScript id={id} dangerouslySetInnerHTML={{ __html: html }} {...props} />
);

/////////////////////////////////////////////////////////////////////////////////

export const HygraphScript: React.FC<Script> = (props) => {
  if (props.sourceUrl) {
    return (
      <NextScript
        id={props.slug}
        src={props.sourceUrl}
        strategy={props.loadStrategy}
      />
    );
  }

  if ((props.body ?? '').trim().length > 0) {
    return (
      <HtmlScript
        id={props.slug}
        html={props.body || ''}
        strategy={props.loadStrategy}
      />
    );
  }

  return null;
};

export default function DynamicScript(props: unknown) {
  return <HygraphScript {...(props as Script)} />;
}
